import { SafeCapType } from 'shared';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { ConversionMethod, ConvertToSharesSummaryDto } from '../../types/safes.types';
import { Stakeholder } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';

export type SafeConversionSummaryResponse = {
  capitalOwned: number;
  capType: null | SafeCapType;
  conversionMethod: ConversionMethod;
  conversionSharePrice: number;
  discount: number;
  floor: number;
  investment: number;
  sharesConverted: number;
  stakeholder: Stakeholder;
  'valuation-cap': number;
};

export const useSafeConversionSummary = () => {
  const {
    mutate: getSafeConversionSummary,
    isPending,
    data,
  } = useAppMutation<
    SafeConversionSummaryResponse,
    HttpException,
    { companyId: string; data: ConvertToSharesSummaryDto; safeId: string }
  >([QueryKey.GET_SAFE_CONVERSION_SUMMARY], {
    mutationFn: ({
      companyId,
      safeId,
      data,
    }: {
      companyId: string;
      data: ConvertToSharesSummaryDto;
      safeId: string;
    }) =>
      ApiService.post(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'safes', safeId, 'convert-summary'],
        },
        { body: data },
      ),
  });

  return { getSafeConversionSummary, isPending, data };
};
